define((require) => {
    "use strict";

    const IntegrationModel = require("editor/ui/settings/integrations/IntegrationModel");

    /**
     * Marker class for Enabling ZSites.
     *
     * @class ZSites
     */
    return IntegrationModel.extend("ZSitesEnabled", {}, {
        type: "ZSitesEnabled"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/ZSitesModel.js